import { useRef } from "react";

const getSortOptionString = ({ sort, sortOrder }) => `${sort}:${sortOrder}`;

const useSortChanged = ({ sort, sortOrder }) => {
  const sortOption = getSortOptionString({ sort, sortOrder });

  const sortOptionRef = useRef(sortOption);

  const prevSortOption = sortOptionRef.current;

  const sortChanged = sortOption !== prevSortOption;

  sortOptionRef.current = sortOption;

  return sortChanged;
};

export default useSortChanged;
